import { Button } from "@/components/ui/button";
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger 
} from "@/components/ui/dropdown-menu";
import { ChevronDown, ChevronUp } from "lucide-react";
import { ViewToggle, ViewMode } from "@/components/common/ViewToggle";
import { useTranslation } from "react-i18next";

export type SortField = "score" | "createdAt";
export type SortOrder = "asc" | "desc";
export type { ViewMode };

interface MatchesViewOptionsProps {
  sortField: SortField;
  setSortField: (field: SortField) => void;
  sortOrder: SortOrder;
  setSortOrder: (order: SortOrder) => void;
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
}

export const MatchesViewOptions = ({
  sortField,
  setSortField,
  sortOrder,
  setSortOrder,
  viewMode,
  setViewMode
}: MatchesViewOptionsProps) => {
  const { t } = useTranslation();
  const getSortLabel = () => {
    switch (sortField) {
      case "score": return t("sortBar.score", "Score");
      case "createdAt": return t("sortBar.dateCreated", "Date Created");
      default: return t("sortBar.sortBy", "Sort by");
    }
  };

  const handleToggleSortOrder = () => {
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  return (
    <>
      <span className="text-sm font-medium text-gray-500 dark:text-gray-400">{t("sortBar.sortBy", "Sort by")}</span>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="flex items-center gap-1">
            {getSortLabel()}
            <ChevronDown className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          <DropdownMenuItem onClick={() => setSortField("score")}>{t("sortBar.score", "Score")}</DropdownMenuItem>
          <DropdownMenuItem onClick={() => setSortField("createdAt")}>{t("sortBar.dateCreated", "Date Created")}</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      
      <Button 
        variant="outline" 
        size="icon" 
        onClick={handleToggleSortOrder}
      >
        {sortOrder === "asc" ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
      </Button>
      
      <ViewToggle 
        viewMode={viewMode}
        onViewModeChange={setViewMode}
        label=""
      />
    </>
  );
}; 